export default __webpack_public_path__ + "static/media/notFound.e973231f.png";